export default __webpack_public_path__ + "static/media/gallery_00.906e68a5.jpg";